import { all, fork, put, takeEvery, call, takeLatest } from 'redux-saga/effects';
import { ClientActionTypes } from './constants';
import { toast, ToastContainer } from 'react-toastify';

import {
    Vendor,
    createVendor,
    updateVendor,
    deleteVendor,
    account,
    createAccount,
    updateAccount,
    deleteAccount,
    uploadAccountData,
    uploadClientData,
} from './api';
/**
 * Login the user
 * @param {*} payload - username and password
 */

function* vendorDataGetFunction(data) {
    try {
        yield put({
            type: ClientActionTypes.VENDOR_DATA_LOADING,
            payload: {},
        });
        const response = yield call(Vendor, data);
        if (response.data.status) {
            yield put({
                type: ClientActionTypes.VENDOR_DATA_SUCCESS,
                payload: { ...response.data },
            });
        } else {
            yield put({
                type: ClientActionTypes.VENDOR_DATA_ERROR,
                payload: { ...response.data },
            });
        }
    } catch (error) {
        yield put({
            type: ClientActionTypes.VENDOR_DATA_ERROR,
            payload: error,
        });
    }
}
function* vendorDataCreateFunction(data) {
    try {
        yield put({
            type: ClientActionTypes.CREATE_VENDOR_DATA_LOADING,
            payload: {},
        });
        const response = yield call(createVendor, data);
        if (response.data.status) {
            yield put({
                type: ClientActionTypes.CREATE_VENDOR_DATA_SUCCESS,
                payload: { ...response.data },
            });
            toast.success(response.data.message);
        } else {
            yield put({
                type: ClientActionTypes.CREATE_VENDOR_DATA_ERROR,
                payload: { ...response.data },
            });
            toast.error(response.data.message);
        }
    } catch (error) {
        yield put({
            type: ClientActionTypes.CREATE_VENDOR_DATA_ERROR,
            payload: error,
        });
        toast.error(error);
    }
}
function* vendorDataUpdateFunction(payload) {
    try {
        yield put({
            type: ClientActionTypes.UPDATE_VENDOR_DATA_LOADING,
        });

        const response = yield call(updateVendor, payload);

        if (response.data) {
            yield put({
                type: ClientActionTypes.UPDATE_VENDOR_DATA_SUCCESS,
                payload: response.data,
            });
            toast.success(response.data.message);
        } else {
            yield put({
                type: ClientActionTypes.UPDATE_VENDOR_DATA_ERROR,
                payload: response.data,
            });
            toast.error(response.data.message);
        }
    } catch (error) {
        yield put({
            type: ClientActionTypes.UPDATE_VENDOR_DATA_ERROR,
            payload: { message: error.message },
        });
        toast.error(error);
    }
}
function* vendorDataDeleteFunction(payload) {
    try {
        yield put({
            type: ClientActionTypes.DELETE_VENDOR_DATA_LOADING,
        });

        const response = yield call(deleteVendor, payload);

        if (response.data) {
            yield put({
                type: ClientActionTypes.DELETE_VENDOR_DATA_SUCCESS,
                payload: response.data,
            });
            toast.success(response.data.message);
        } else {
            yield put({
                type: ClientActionTypes.DELETE_VENDOR_DATA_ERROR,
                payload: response.data,
            });
            toast.error(response.data.message);
        }
    } catch (error) {
        yield put({
            type: ClientActionTypes.DELETE_VENDOR_DATA_ERROR,
            payload: { message: error.message },
        });
        toast.error(error);
    }
}

function* uploadClientDataFunction(data) {
    try {
        yield put({
            type: ClientActionTypes.UPLOAD_CLIENT_DATA_LOADING,
            payload: {},
        });
        const response = yield call(uploadClientData, data);
        if (response.data) {
            yield put({
                type: ClientActionTypes.UPLOAD_CLIENT_DATA_SUCCESS,
                payload: { ...response.data },
            });
            toast.success(response.data.message);
        } else {
            yield put({
                type: ClientActionTypes.UPLOAD_CLIENT_DATA_ERROR,
                payload: { ...response.data },
            });
            toast.error(response.data.message);
        }
    } catch (error) {
        yield put({
            type: ClientActionTypes.UPLOAD_CLIENT_DATA_ERROR,
            payload: error,
        });
    }
}

// ------_--_-_-____-_-_---_--_-_-

function* accountDataGetFunction(data) {
    try {
        yield put({
            type: ClientActionTypes.ACCOUNT_DATA_LOADING,
            payload: {},
        });
        const response = yield call(account, data);
        if (response.data.status) {
            yield put({
                type: ClientActionTypes.ACCOUNT_DATA_SUCCESS,
                payload: { ...response.data },
            });
        } else {
            yield put({
                type: ClientActionTypes.ACCOUNT_DATA_ERROR,
                payload: { ...response.data },
            });
        }
    } catch (error) {
        yield put({
            type: ClientActionTypes.ACCOUNT_DATA_ERROR,
            payload: error,
        });
    }
}
function* accountDataCreateFunction(data) {
    try {
        yield put({
            type: ClientActionTypes.CREATE_ACCOUNT_DATA_LOADING,
            payload: {},
        });
        const response = yield call(createAccount, data);
        if (response.data.status) {
            yield put({
                type: ClientActionTypes.CREATE_ACCOUNT_DATA_SUCCESS,
                payload: { ...response.data },
            });
            toast.success(response.data.message);
        } else {
            yield put({
                type: ClientActionTypes.CREATE_ACCOUNT_DATA_ERROR,
                payload: { ...response.data },
            });
            toast.error(response.data.message);
        }
    } catch (error) {
        yield put({
            type: ClientActionTypes.CREATE_ACCOUNT_DATA_ERROR,
            payload: error,
        });
        toast.error(error);
    }
}
function* accountDataUpdateFunction(payload) {
    try {
        yield put({
            type: ClientActionTypes.UPDATE_ACCOUNT_DATA_LOADING,
        });

        const response = yield call(updateAccount, payload);

        if (response.data) {
            yield put({
                type: ClientActionTypes.UPDATE_ACCOUNT_DATA_SUCCESS,
                payload: response.data,
            });
            toast.success(response.data.message);
        } else {
            yield put({
                type: ClientActionTypes.UPDATE_ACCOUNT_DATA_ERROR,
                payload: response.data,
            });
            toast.error(response.data.message);
        }
    } catch (error) {
        yield put({
            type: ClientActionTypes.UPDATE_ACCOUNT_DATA_ERROR,
            payload: { message: error.message },
        });
        toast.error(error);
    }
}
function* accountDataDeleteFunction(payload) {
    try {
        yield put({
            type: ClientActionTypes.DELETE_ACCOUNT_DATA_LOADING,
        });

        const response = yield call(deleteAccount, payload);

        if (response.data) {
            yield put({
                type: ClientActionTypes.DELETE_ACCOUNT_DATA_SUCCESS,
                payload: response.data,
            });
            toast.success(response.data.message);
        } else {
            yield put({
                type: ClientActionTypes.DELETE_ACCOUNT_DATA_ERROR,
                payload: response.data,
            });
            toast.error(response.data.message);
        }
    } catch (error) {
        yield put({
            type: ClientActionTypes.DELETE_ACCOUNT_DATA_ERROR,
            payload: { message: error.message },
        });
        toast.error(error);
    }
}

function* uploadAccountDataFunction(data) {
    try {
        yield put({
            type: ClientActionTypes.UPLOAD_ACCOUNT_DATA_LOADING,
            payload: {},
        });
        const response = yield call(uploadAccountData, data);
        if (response.data) {
            yield put({
                type: ClientActionTypes.UPLOAD_ACCOUNT_DATA_SUCCESS,
                payload: { ...response.data },
            });
            toast.success(response.data.message);
        } else {
            yield put({
                type: ClientActionTypes.UPLOAD_ACCOUNT_DATA_ERROR,
                payload: { ...response.data },
            });
            toast.error(response.data.message);
        }
    } catch (error) {
        yield put({
            type: ClientActionTypes.UPLOAD_ACCOUNT_DATA_ERROR,
            payload: error,
        });
        toast.error(error);
    }
}

export function* watchVendorDataGet() {
    yield takeLatest(ClientActionTypes.VENDOR_DATA_FIRST, vendorDataGetFunction);
    yield takeLatest(ClientActionTypes.ACCOUNT_DATA_FIRST, accountDataGetFunction);
}
export function* watchVendorDataCreate() {
    yield takeEvery(ClientActionTypes.CREATE_VENDOR_DATA_FIRST, vendorDataCreateFunction);
    yield takeEvery(ClientActionTypes.CREATE_ACCOUNT_DATA_FIRST, accountDataCreateFunction);
    yield takeEvery(ClientActionTypes.UPLOAD_CLIENT_DATA_FIRST, uploadClientDataFunction);
    yield takeEvery(ClientActionTypes.UPLOAD_ACCOUNT_DATA_FIRST, uploadAccountDataFunction);
}
export function* watchVendorDataUpdate() {
    yield takeLatest(ClientActionTypes.UPDATE_VENDOR_DATA_FIRST, vendorDataUpdateFunction);
    yield takeLatest(ClientActionTypes.UPDATE_ACCOUNT_DATA_FIRST, accountDataUpdateFunction);
}
export function* watchVendorDataDelete() {
    yield takeEvery(ClientActionTypes.DELETE_VENDOR_DATA_FIRST, vendorDataDeleteFunction);
    yield takeEvery(ClientActionTypes.DELETE_ACCOUNT_DATA_FIRST, accountDataDeleteFunction);
}

function* clientSaga() {
    yield all([
        fork(watchVendorDataGet),
        fork(watchVendorDataCreate),
        fork(watchVendorDataUpdate),
        fork(watchVendorDataDelete),
    ]);
}

export default clientSaga;
